import { createActionCreator } from '../../utils/helpers';

import { updateFundingEnquiryStatus } from './types';

export const requestUpdateFundingEnquiryStatus = createActionCreator(
  updateFundingEnquiryStatus.request,
  'id',
  'status',
  'promise',
);
export const requestUpdateFundingEnquiryStatusSuccess = createActionCreator(
  updateFundingEnquiryStatus.success,
  'data',
);
export const requestUpdateFundingEnquiryStatusFailure = createActionCreator(
  updateFundingEnquiryStatus.failure,
);
